var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'cz2__header-bar',
    {
        'cz2__header-bar--with-toast': _vm.hasToastMessage,
    }
]},[_c('button',{staticClass:"cz2__header-bar__close",attrs:{"aria-label":_vm.$t('MENU_CLOSE')},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }